<div class="wtr-fx-layout-column" id="shell-container" *ngIf="configLoaded">
  <div id="wlm-top-bar-container">
    <ng-container
      *ngIf="topBarRef && !hideTopBar"
      [ngTemplateOutlet]="topBarRef"
      [ngTemplateOutletContext]="{}"
    >
    </ng-container>
  </div>

  <div id="shell-content" class="wtr-fx-layout">
    <div
      id="main-content"
      *ngIf="navBarRef"
      [style.max-width]="mainContentWidthFx ? mainContentWidthFx + '%' : null"
    >
      <ng-container [ngTemplateOutlet]="navBarRef" [ngTemplateOutletContext]="{}"> </ng-container>
    </div>
    <div
      id="rpanel"
      [style.max-width]="rightPanelWidthFx ? rightPanelWidthFx + '%' : null"
      *ngIf="rightPanelVisible | async"
      [ngClass]="{ hovering: (rightPanelHover | async) }"
    >
      <div
        class="side-bar-box"
        cdkDragLockAxis="x"
        cdkDrag
        [cdkDragFreeDragPosition]="dragPosition"
        (cdkDragEnded)="dragEnded2($event)"
      ></div>

      <div id="rpanel-container">
        <wlm-gl-detail-panel class="wtr-fx-layout-column wtr-fx-flex-grow"></wlm-gl-detail-panel>
      </div>
    </div>
  </div>
</div>
